import type {historyLineItem} from '@/types/order'
import axios from './orderInstance'

// See getHistoryOrder: errors propagate rather than collapsing into `null`.
export default async (orderId: string, id: string): Promise<historyLineItem[]> => {
    const response = await axios.get<historyLineItem[]>(`/orders/${orderId}/line-items/${id}/history`)
    return response.data
}
